'use strict';
/**
 * [init initilizes tabs]
 * @param  {[string]} scope [css selector]
 * @return {[undefined]}    [nothing returned]
 */
export function init(scope){

    $('.quick-support-bar a:not(.has-url)').on('click', function(){
        if($(this).hasClass('quick-support--current')){
            return false;
        }

        let id = $(this).attr('href');

        $('.quick-support-bar a:not(.has-url)').removeClass('quick-support--current');

        $(this).addClass('quick-support--current');


        let opened = $('.quick-support-content:visible');

        if(opened.length){
            $('.quick-support-content:visible').slideUp(function(){
                $(id).slideToggle();
            });
        }else {
            $(id).slideToggle();
        }

        return false;
    });

    $('.quick-support-content').on('click', '.btn-close', function(){
        $('.quick-support-bar a:not(.has-url)').removeClass('quick-support--current');
        $('.quick-support-content:visible').slideToggle();
        return false;
    });



    var rval = $('#donation-input');
    var rvalExt = rval.data('extension');
    $('#donation-range').rangeslider({

        // Feature detection the default is `true`.
        // Set this to `false` if you want to use
        // the polyfill also in Browsers which support
        // the native <input type="range"> element.
        polyfill: false,

        // Default CSS classes
        fillClass: 'rangeslider-fill',
        handleClass: 'rangeslider-handle',

        // Callback function
        onInit: function() {
        },

        // Callback function
        onSlide: function(position, value) {
            rval.val(value + rvalExt);
        },

        // Callback function
        onSlideEnd: function() {

        }
    });

    rval.on('blur', function(){
        $('#donation-range').val($(this).val().replace(rvalExt, '')).change();
    }).on('focus', function() {
        $(this).val($(this).val().replace(rvalExt, ''));
    });


}
